import axios from "axios";

import { Lead_Service_URL } from "../Url";
import { clearLogoutData } from "../logout/action";

export const getLeadActions = {
  GET_LEAD_SUCCESS: "GET_LEAD_SUCCESS",
  GET_LEAD_ERROR: "GET_LEAD_ERROR",
};

export function getLeadDetails(props) {
  const { access_token, leadId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/get/LeadDetails?leadId=${leadId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getLeadSuccess(response.data));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getLeadError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getLeadError(err));
          return err.response;
        }
      });
}

export function getLeadError(error) {
  return {
    type: getLeadActions.GET_LEAD_ERROR,
    payload: error,
  };
}

export function getLeadSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getLeadActions.GET_LEAD_SUCCESS,
      payload: props,
    });
  };
}
